import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextInput } from "./simple-text-input";
import type { InputProps, PathProps } from "./types";

const notices = ["スマート申請を利用しない場合の、電子申請のURLを記述します。"];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureOnlineInfoApplicationUrlInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="電子申請のURL" required />
      <InputNoticeList notices={notices} />
      <SimpleTextInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
      />
    </div>
  );
};
